import { Box, FormLabel, Grid, TextField, Typography } from '@mui/material';
import { useActividadesContext } from '../../UmmIACategories/Hook/useActividades';

const DescripcionClasesPrevias = () => {
  
  const { promptData, setPromptData} = useActividadesContext();
  const handleDescripcionClasesPrevias = (event) => {
    const descripcionClasesPrevias = event.target.value;
   
    setPromptData((prevData) => ({
        ...prevData,
        descripcion_clases_previas: descripcionClasesPrevias 
      }));
  };

  return (
    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
      <Box>
      <Box sx={{ display: 'flex', flexDirection: 'column',  }}>
        <Typography sx={{ fontFamily: 'montserrat', fontSize: '1.25rem', fontWeight: 'bold', color: '#336B87' }}>
            Descripción de lo trabajado durante las clases anteriores
        </Typography>
        <FormLabel sx={{ fontFamily: 'montserrat', fontSize: '0.85rem', mt:1 }}>Describe cómo has trabajado estos contenidos durante las clases con tus estudiantes para generar tareas más pertinentes</FormLabel>
        </Box>
        <TextField
          fullWidth
          variant="outlined"
          value={promptData.descripcion_clases_previas}
          placeholder="Escribe aquí la descripción de lo trabajado durante las clases. Ejemplo: Categorizamos alimentos saludables y no saludables, y vimos las razones"
          onChange={handleDescripcionClasesPrevias}
          InputProps={{
            sx: {
              borderRadius:2,
                mt:1,
                mb: 3,
                fontFamily: 'montserrat',
                fontSize: '0.75rem', 
                color: '#336B87',
                '&::placeholder': {
                    color: '#005559',

                },
                '&:before': {
                    borderBottomColor: '#005559',

                },
                '&:after': {
                    borderBottomColor: '#005559',
                },
            }
        }}
        />
      </Box>
    </Grid>
  );
};

export default DescripcionClasesPrevias;
